/**
 * Format a voice-note duration (in seconds) as `m:ss` (or `h:mm:ss` past an hour).
 * Mirrors the Flutter `voice_duration_formatter`. Negative / non-finite input
 * renders as `0:00`.
 */
export function formatVoiceDuration(totalSeconds: number): string {
  const safe = Number.isFinite(totalSeconds) && totalSeconds > 0 ? Math.floor(totalSeconds) : 0
  const hours = Math.floor(safe / 3600)
  const minutes = Math.floor((safe % 3600) / 60)
  const seconds = safe % 60
  const ss = seconds.toString().padStart(2, '0')
  if (hours > 0) {
    const mm = minutes.toString().padStart(2, '0')
    return `${hours}:${mm}:${ss}`
  }
  return `${minutes}:${ss}`
}
